// Wait for Swiper to be loaded
function initSwipers() {
	if ( ! window.Swiper ) {
		// Swiper not loaded yet, retry
		setTimeout( initSwipers, 100 );
		return;
	}

	const swipers = document.querySelectorAll( '.sis-swiper' );

	swipers.forEach( ( swiperEl ) => {
		// Skip if already initialized
		if ( swiperEl.classList.contains( 'swiper-initialized' ) ) {
			return;
		}

		const blockId = swiperEl.getAttribute( 'data-block-id' );
		const prevBtn = document.querySelector( `.sis-nav-prev[data-block-id="${ blockId }"]` );
		const nextBtn = document.querySelector( `.sis-nav-next[data-block-id="${ blockId }"]` );

		try {
			new window.Swiper( swiperEl, {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 20,
				navigation: {
					prevEl: prevBtn,
					nextEl: nextBtn,
				},
				breakpoints: {
					// Mobile: 1 card
					0: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					// Tablet: 1 card
					768: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					// Desktop: 2 cards
					1024: {
						slidesPerView: 2,
						spaceBetween: 40,
						centeredSlides: false,
					},
				},
			} );

			swiperEl.classList.add( 'swiper-initialized' );
		} catch ( e ) {
			console.error( 'Swiper initialization error:', e );
		}
	} );
}

// Initialize when DOM is ready
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initSwipers );
} else {
	initSwipers();
}
